import { MixinsOptions } from '@mui/material/styles/createMixins';

export const themeMixins: MixinsOptions = {
  toolbar: {
    minHeight: '48px',
    padding: '16px',
    '@media (min-width: 600px)': {
      minHeight: '48px',
    },
  },
};
